const Form014SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInfo: "申请资料",
        confirmation: "确认",
    },
    label: {
        title: {
            tips: "申请向教师发还课程费用",
            tipsA: "学校资料",
        },
        selection: {
            schoolHead: "校长",
            teacher: "教师",
        },
        schoolHeadOption: {
            supervisor: "校监",
            schoolHead: "校长",
        },
        nameOfApplicant: "申请人姓名",
        courseTitle: "课程名称",
        courseDuration: "课程日期",
        courseStartDate: "课程开始日期",
        courseEndDate: "课程结束日期",
        courseFee: "课程费用",
        refundAmountA: "建议发还的课程费用金额",
        refundAmountB: "经批核发还的课程费用金额（只供教育局人员填写）",
        refundAmountATotal: "建议发还的课程费用总金额",
        name: "审批人姓名（校监／校长）",
        schoolRegistrationName: "学校注册名称",
        schoolRegistrationNo: "学校注册编号",
        accountPayee: "支票抬头名称（仅限学校账户）",
        schoolRegistrationAddress: "学校注册地址",
        schoolEmailAddress: "学校电邮地址",
        telephoneNo: "电话号码",
        faxNo: "传真号码",
        schoolHeadOrTeacher: "本申请的申请人包括",
        supervisorOrschoolHead: "审批人（向教育局签署及提交此申请的人）",
        supportDoc: "证明文件",
        pisc: "个人资料收集声明",
        declarationText: "声明（待审批人确认）",
        declarationTextApprover1: "声明（",
        declarationTextApprover2:
            "请阅读以下声明。一经签署并提交本申请，即表示您作为审批人已作出下列声明。",
        note: {
            note1: "本人为申请人所任职学校的<b>{{positionOne}}</b>，现签署以确认上述<b>{{positionTwo}}</b>已完成课程，并符合<b>{{dateTime}}</b>发出的教育局通函<b>{{clauseText}}</b>所载的要求。上述<b>{{positionTwo}}</b>从未就同一项课程获得公帑资助。本校会妥善保存由课程机构所发出的",
            note1A: "正式收据正本，以及成绩单、证书及相关文件的副本，",
            note1B: "以供教育局随时审阅。",
            note2: "总额（不多于港币{{totalAmount}}元）",
            note3: "发还课程费用的安排只适用于在{{note1Start}}至{{note1End}}期间完成的课程。",
        },
        importNotesList: {
            oneText:
                "请细阅教育局通函{{clauseText}}「向教师发还课程费用」，以了解申请程序及要求。",
            twoText:
                "当校长／教师完成有关课程后，请其校监／校长于<b>{{periodText}}</b>期间递交申请， 为有关校长／教师申请发还课程费用。<b>逾期申请概不受理</b>。",
            threeText:
                "学校须妥善记录及保存有关校长／教师曾修读的课程资料，包括正式收据正本，以及成绩单、证书及相关文件的副本，以供教育局随时审阅。",
            fourText:
                "如校监／校长作为审批人有已启用数码签署功能的「智方便+」帐户，他／她可直接透过此电子平台向教育局递交申请。否则，校监／校长需要下载和签署已填妥的申请表格，并以传真或邮寄方式将申请表格递交至教育局培训小组。",
        },
        refundRemark:
            "如有11位或更多的申请者申请发还课程费用，您可以表列及上载有关申请的资料（包括申请者姓名、课程名称、课程日期、课程费用、建议发还的课程费用金额和建议发还的课程费用总金额），并以Excel／Word文件格式上载为补充文件予教育局作审批。",
    },
    label1: {
        header: {
            headerOne: "声明",
        },
        statement: "本人已阅读及明白上述重要提示及个人资料收集声明",
        statement2:
            "我理解审批人需要拥有「智方便+」帐户才能直接透过此电子平台向教育局递交申请",
    },

    errorMsg: {
        // required: "此字段必填",
        email: "请输入正确的电邮地址",
        courseRefund: "此项不可多于港币{{amount}}元",
        lessCourseFee: "建议发还的课程费用金额不能超过课程费用",
        numLimit: "请输入{{limit}}",
        numLimit2: "总额不多于{{limit}}",
        number: "请输入正确格式的编号",
        checkIsRequired: "请阅读上述重要提示及个人资料收集声明，并勾选此选项",
        checkRead: "请阅读上述重要提示，并勾选此选项",
        minDigit: "此项最少需要填写{{min}}个数字",
        checkSchoolHead: "如校长申请发还课程费用，此表格须由校监签署",
        checkApproverRole: "请参照上述已选择的职位，选择对应的审批人",

        length: {
            note: "长度不得超过50个字符",
            note1: "长度不得超过100个字符",
            note2: "长度不得超过200个字符",
            note3: "长度不得超过1000个字符",
        },
        tel: {
            rule: "请输入一个有效的8位电话号码",
            digit: "必须为8位电话号码",
        },
        fax: {
            rule: "请输入一个有效的8位传真号码",
            digit: "必须为8位传真号码",
        },
        date: {
            rule: "请输入有效日期",
            todayOrBefore: "请选择今天或之前",
            afterThisDate: "请在之后选择日期{{targetDate}}",
            age: "申请人在提交时至少年满18岁。",
        },
    },
};
export default Form014SC;
